module.exports = __webpack_public_path__ + "static/media/bank-bcv.e6fb2095.svg";